import { IShiftCustomFieldDropdownInputOption } from 'components/ShiftModal/src/components/ShiftCustomFieldInput/ShiftCustomFieldInput.types';
import { CustomField } from 'types/graphql';

export const getShiftCustomFieldDropdownInputOptions = (
  customField: CustomField,
): IShiftCustomFieldDropdownInputOption[] => {
  let options: IShiftCustomFieldDropdownInputOption[];
  options = (customField.customFieldOptions || []).map((option) => {
    return {
      key: option.value,
      label: option.value,
      value: option.value,
    };
  });
  if (options)
    options.push({
      key: 'none',
      label: 'None',
      value: '',
    });
  return options;
};
